export default "__VITE_ASSET__D5ROo0BJ__"